import { Button, Grid, MenuItem, TextField } from '@material-ui/core'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import React, { FC } from 'react'

import {
  fieldError,
  fieldErrorText,
  nextDisabled,
  onNext,
  PardotFormProps,
} from '../../utils/form/useForm'
import { cleanString } from '../../utils/helpers'
import SectionWrapper, { SectionWrapperProps } from './SectionWrapper'
import { CenterContainer, Column } from './styles'

interface StepTwoProps extends SectionWrapperProps {
  form: PardotFormProps
  handleNext: () => void
  handlePrev: () => void
  companyNameLabel?: string
  numberOfSellersLabel?: string
  phoneNumberLabel?: string
  jobTitleLabel?: string
  businessEmailLabel?: string
  countriesLabel?: string
  countries?: {
    id: string
    copy: string
  }[]
}
const useStyles = makeStyles(() =>
  createStyles({
    button: {
      backgroundColor: '#E9B265',
      fontWeight: 'bold',
      color: 'white',
    },
  }),
)
const StepTwo: FC<StepTwoProps> = ({
  form,
  form: { values, handleChange },
  handleNext,
  handlePrev,
  countries,
  currentSlide,
  headline,
  companyNameLabel,
  numberOfSellersLabel,
  phoneNumberLabel,
  jobTitleLabel,
  businessEmailLabel,
  countriesLabel,
}) => {
  const classes = useStyles()

  const stepTwoFields = [
    'companyName',
    'numberOfSellers',
    'phoneNumber',
    'jobTitle',
    'businessEmail',
    'country',
  ] as const

  return (
    <CenterContainer>
      <SectionWrapper currentSlide={currentSlide} headline={headline}>
        <Grid
          container
          justifyContent="space-between"
          style={{ marginBottom: '24px' }}
        >
          <Column>
            <TextField
              disabled={currentSlide !== 1}
              error={fieldError(form, 'companyName')}
              helperText={fieldErrorText(form, 'companyName')}
              id="companyName"
              label={companyNameLabel}
              name="companyName"
              onChange={handleChange}
              value={values.companyName}
              variant="filled"
            />
            <TextField
              disabled={currentSlide !== 1}
              error={fieldError(form, 'numberOfSellers')}
              helperText={fieldErrorText(form, 'numberOfSellers')}
              id="numberOfSellers"
              label={numberOfSellersLabel}
              name="numberOfSellers"
              onChange={handleChange}
              value={values.numberOfSellers}
              variant="filled"
            />
            <TextField
              disabled={currentSlide !== 1}
              error={fieldError(form, 'phoneNumber')}
              helperText={fieldErrorText(form, 'phoneNumber')}
              id="phoneNumber"
              label={phoneNumberLabel}
              name="phoneNumber"
              onChange={handleChange}
              value={values.phoneNumber}
              variant="filled"
            />
          </Column>
          <Column>
            <TextField
              disabled={currentSlide !== 1}
              error={fieldError(form, 'jobTitle')}
              helperText={fieldErrorText(form, 'jobTitle')}
              id="jobTitle"
              label={jobTitleLabel}
              name="jobTitle"
              onChange={handleChange}
              value={values.jobTitle}
              variant="filled"
            />
            <TextField
              disabled={currentSlide !== 1}
              error={fieldError(form, 'businessEmail')}
              helperText={fieldErrorText(form, 'businessEmail')}
              id="businessEmail"
              label={businessEmailLabel}
              name="businessEmail"
              onChange={handleChange}
              value={values.businessEmail}
              variant="filled"
            />
            <TextField
              disabled={currentSlide !== 1}
              error={fieldError(form, 'country')}
              helperText={fieldErrorText(form, 'country')}
              id="country"
              label={countriesLabel}
              name="country"
              onChange={handleChange}
              select
              value={values.country}
              variant="filled"
            >
              {countries?.map((country) => (
                <MenuItem key={country.id} value={cleanString(country.copy)}>
                  {cleanString(country.copy)}
                </MenuItem>
              ))}
            </TextField>
          </Column>
        </Grid>
        <Grid
          container
          item
          justifyContent="space-between"
          style={{ marginTop: 'auto' }}
        >
          <Button
            className={classes.button}
            disableElevation
            disabled={currentSlide !== 1}
            onClick={handlePrev}
            variant="contained"
          >
            {'<'} Back
          </Button>
          <Button
            className={classes.button}
            disableElevation
            disabled={currentSlide !== 1 || nextDisabled(form, stepTwoFields)}
            onClick={onNext(form, stepTwoFields, handleNext)}
            variant="contained"
          >
            Next {'>'}
          </Button>
        </Grid>
      </SectionWrapper>
    </CenterContainer>
  )
}

export default StepTwo
